(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-review-slideshow';
  var SCROLL_SETTLE_FALLBACK_MS = 800;
  var sectionState = new Map();

  function initSection(section) {
    if (!section || section.dataset.odditInitialized === 'true') return;
    section.dataset.odditInitialized = 'true';

    var track = section.querySelector('[data-review-slideshow-track]');
    var prevBtn = section.querySelector('[data-review-slideshow-prev]');
    var nextBtn = section.querySelector('[data-review-slideshow-next]');
    var indicatorsList = section.querySelector('[data-review-slideshow-indicators]');

    if (!track) return;

    var state = {
      dots: [],
      cardsPerView: 1,
      pageCount: 1,
      currentPage: 0,
      programmaticScroll: false,
      programmaticTimer: null,
      scrollendHandler: null,
      resizeObserver: null,
      autoplayTimer: null
    };

    function getCards() {
      return Array.prototype.slice.call(track.children);
    }

    function getStepWidth() {
      var cards = getCards();
      if (cards.length < 2) {
        return cards[0] ? cards[0].getBoundingClientRect().width : 0;
      }
      var firstRect = cards[0].getBoundingClientRect();
      var secondRect = cards[1].getBoundingClientRect();
      return secondRect.left - firstRect.left;
    }

    function getCardsPerView() {
      var step = getStepWidth();
      if (step <= 0) return 1;
      return Math.max(1, Math.round(track.clientWidth / step));
    }

    function getCurrentCardIndex() {
      var step = getStepWidth();
      if (step <= 0) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function getCurrentPageFromScroll() {
      var cpv = state.cardsPerView;
      if (cpv <= 0) return 0;
      var page = Math.round(getCurrentCardIndex() / cpv);
      return Math.max(0, Math.min(page, state.pageCount - 1));
    }

    function armScrollSettle() {
      if (state.programmaticTimer) {
        clearTimeout(state.programmaticTimer);
        state.programmaticTimer = null;
      }
      if (state.scrollendHandler) {
        track.removeEventListener('scrollend', state.scrollendHandler);
        state.scrollendHandler = null;
      }

      var release = function () {
        state.programmaticScroll = false;
        if (state.scrollendHandler) {
          track.removeEventListener('scrollend', state.scrollendHandler);
          state.scrollendHandler = null;
        }
        if (state.programmaticTimer) {
          clearTimeout(state.programmaticTimer);
          state.programmaticTimer = null;
        }
      };

      state.scrollendHandler = release;
      track.addEventListener('scrollend', release, { once: true, passive: true });
      state.programmaticTimer = setTimeout(release, SCROLL_SETTLE_FALLBACK_MS);
    }

    function scrollToPage(page) {
      if (state.pageCount <= 1) return;
      if (page < 0) page = state.pageCount - 1;
      if (page > state.pageCount - 1) page = 0;
      state.currentPage = page;

      var step = getStepWidth();
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = Math.min(step * state.cardsPerView * page, maxScroll);

      state.programmaticScroll = true;
      track.scrollTo({ left: target, behavior: 'smooth' });
      armScrollSettle();

      updateActiveDot(page);
      updateButtonStates(page);
    }

    function updateActiveDot(activePage) {
      state.dots.forEach(function (dot, i) {
        var isActive = i === activePage;
        dot.classList.toggle('oddit-section-review-slideshow__indicator--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function updateButtonStates(activePage) {
      var isCarousel = state.pageCount > 1;
      if (prevBtn) {
        prevBtn.hidden = !isCarousel;
        prevBtn.disabled = !isCarousel;
      }
      if (nextBtn) {
        nextBtn.hidden = !isCarousel;
        nextBtn.disabled = !isCarousel;
      }
    }

    function buildIndicators() {
      if (!indicatorsList) return;
      indicatorsList.innerHTML = '';
      state.dots = [];

      if (state.pageCount <= 1) {
        var li = document.createElement('li');
        var span = document.createElement('span');
        span.className =
          'oddit-section-review-slideshow__indicator ' +
          'oddit-section-review-slideshow__indicator--active ' +
          'oddit-section-review-slideshow__indicator--static';
        span.setAttribute('aria-hidden', 'true');
        li.appendChild(span);
        indicatorsList.appendChild(li);
        return;
      }

      for (var p = 0; p < state.pageCount; p++) {
        var item = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oddit-section-review-slideshow__indicator';
        btn.setAttribute('aria-label', 'Go to page ' + (p + 1));
        var inner = document.createElement('span');
        inner.setAttribute('aria-hidden', 'true');
        inner.innerHTML = '&zwnj;';
        btn.appendChild(inner);
        (function (pageIndex) {
          btn.addEventListener('click', function () {
            stopAutoplay();
            scrollToPage(pageIndex);
          });
        })(p);
        item.appendChild(btn);
        indicatorsList.appendChild(item);
        state.dots.push(btn);
      }
    }

    function recompute() {
      var cards = getCards();
      var cpv = getCardsPerView();
      var pages = Math.max(1, Math.ceil(cards.length / cpv));
      var changed = cpv !== state.cardsPerView || pages !== state.pageCount;
      state.cardsPerView = cpv;
      state.pageCount = pages;
      if (changed) buildIndicators();
      var page = getCurrentPageFromScroll();
      state.currentPage = page;
      updateActiveDot(page);
      updateButtonStates(page);
    }

    function syncFromScroll() {
      var page = getCurrentPageFromScroll();
      state.currentPage = page;
      updateActiveDot(page);
      updateButtonStates(page);
    }

    // ---- Autoplay (opt-in via data-autoplay="true") ----
    function startAutoplay() {
      stopAutoplay();
      if (section.dataset.autoplay !== 'true') return;
      if (state.pageCount <= 1) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var seconds = parseFloat(section.dataset.autoplaySpeed) || 5;
      state.autoplayTimer = setInterval(function () {
        scrollToPage(state.currentPage + 1);
      }, seconds * 1000);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollToPage(state.currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollToPage(state.currentPage + 1);
      });
    }

    track.addEventListener('scroll', function () {
      if (state.programmaticScroll) return;
      syncFromScroll();
    }, { passive: true });

    // Pause autoplay on user interaction with the track itself.
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
      track.addEventListener(evt, stopAutoplay, { passive: true });
    });

    if (typeof ResizeObserver === 'function') {
      state.resizeObserver = new ResizeObserver(function () {
        recompute();
      });
      state.resizeObserver.observe(track);
    }

    recompute();
    startAutoplay();
    sectionState.set(section.id || section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section.id || section);
    if (!state) return;
    if (state.programmaticTimer) clearTimeout(state.programmaticTimer);
    if (state.autoplayTimer) clearInterval(state.autoplayTimer);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    sectionState.delete(section.id || section);
    section.dataset.odditInitialized = '';
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
